import { render } from "./ReumTextBox.vue?vue&type=template&id=3a270cc2"
import script from "./ReumTextBox.vue?vue&type=script&lang=js"
export * from "./ReumTextBox.vue?vue&type=script&lang=js"

import "./ReumTextBox.vue?vue&type=style&index=0&id=3a270cc2&lang=scss"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__